export default __webpack_public_path__ + "assets/webgl/Suzanne_BaseColor.11418baf.png";